import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { PuzzleProvider } from "./contexts/PuzzleContext";
import { MapProvider } from "./contexts/MapContext";

ReactDOM.render(
  <React.StrictMode>
    <MapProvider>
      <PuzzleProvider>
        <App />
      </PuzzleProvider>
    </MapProvider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
